export default __webpack_public_path__ + "static/media/6_2.6593ac06.png";